import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function glucoseEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-glucose.svg').default,
    title: 'life_id.glucose',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.glucose) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.glucose];
  const lastRecord = vitalData.glucose.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'GLUCOSE' as const,
    isEmpty: false,
    average: vitalData.glucose.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.GLUCOSE.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.GLUCOSE.unit}`,
      value: lastRecord.glucose || '-',
      ...getGraphData(settings, [lastRecord.glucose]),
    },
    urlPart: config.GLUCOSE.urlPart,
  };
}
